<template>
  <v-card outlined>
    <v-row no-gutters align="center">
      <v-col cols="1">
        <v-row justify="center">
          <v-icon>add_circle_outline</v-icon>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-select
          :items="processMeasureSetOptions"
          :item-text="(e) => 'Nr. ' + e.seq_nr + ' - ' + e.type"
          item-value="id"
          label="allgemeine TOM auswählen"
          v-model="selectedMeasureSet"
        ></v-select>
      </v-col>
      <v-col cols="8"></v-col>
    </v-row>
  </v-card>
</template>

<script>
import { createProcessMeasureSet } from "../graphql/mutations";

export default {
  name: "ProcessMeasureSetCreateView",
  props: {
    processMeasureSetOptions: Array,
    companyId: String,
    processTextHeader: String,
  },
  components: {},
  computed: {
    createProcessMeasureSetMutation() {
      return this.$Amplify.graphqlOperation(createProcessMeasureSet, { input: this.processMeasureSet });
    },
  },
  watch: {
    selectedMeasureSet: function(measureSetId) {
      if (!!measureSetId) {
        this.$eventHub.emit("sync-status-syncing");
        this.selectedMeasureSet = null;
        this.processMeasureSet = {
          processMeasureSetProcessId: this.$route.params.pid,
          processMeasureSetMeasureSetId: measureSetId,
          status: "OPEN",
        };
        this.$Amplify.API.graphql(this.createProcessMeasureSetMutation)
          .then((response) => {
            this.processMeasureSet.id = response.data.createProcessMeasureSet.id;
            this.$recordCreate(this.companyId, "PROCESSMEASURESET", this.processMeasureSet, (res, err) => {
              res
                ? console.log("logged PROCESSMEASURESET create", res)
                : console.error("error logging PROCESSMEASURESET create", err, e);
            });
            this.$emit("processMeasureSetCreated", response.data.createProcessMeasureSet);
            this.$eventHub.emit("sync-status-success", {
              entity_type: "Verknüpfung von Verfahren",
              entity_label: this.processTextHeader,
              sync_type: "create",
            });
          })
          .catch((err) => {
            this.$eventHub.emit("sync-status-failure", {
              entity_type: "Verknüpfung von Verfahren",
              entity_label: this.processTextHeader,
              sync_type: "create",
              error: err.errors[0].message,
            });
          });
      }
    },
  },
  mounted() {},
  methods: {},
  data: () => ({
    selectedMeasureSet: null,
    processMeasureSet: null,
  }),
};
</script>
